module.exports = __webpack_public_path__ + "img/dispose1.8be5e2b3.png";